
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 13a6.5 6.5 0 116.5-6.5A6.5 6.5 0 0112 13zm0-12a5.5 5.5 0 105.5 5.5A5.5 5.5 0 0012 1zM5.5 24h-1v-2.5A7.5 7.5 0 0112 14v1a6.5 6.5 0 00-6.5 6.5zm12.32 0a5.5 5.5 0 01-1.38-.18.5.5 0 01-.37-.5 1 1 0 00-.95-1.06.95.95 0 00-.6.16.5.5 0 01-.63-.07 5.52 5.52 0 01-1.37-2.38.5.5 0 01.25-.58 1 1 0 00.44-1.34.99.99 0 00-.44-.44.5.5 0 01-.25-.58 5.52 5.52 0 011.37-2.38.5.5 0 01.63-.07 1 1 0 001.55-.9.5.5 0 01.37-.5 5.51 5.51 0 012.75 0 .5.5 0 01.38.5 1 1 0 001.54.9.5.5 0 01.63.07 5.53 5.53 0 011.38 2.38.5.5 0 01-.26.58 1 1 0 000 1.78.5.5 0 01.26.58 5.5 5.5 0 01-1.38 2.38.5.5 0 01-.63.07 1 1 0 00-1.54.9.5.5 0 01-.38.5 5.46 5.46 0 01-1.37.18zm-.78-1.07a4.5 4.5 0 001.56 0 1.98 1.98 0 01.3-.76 2 2 0 012.37-.78 4.51 4.51 0 00.78-1.35 1.98 1.98 0 01-.51-.63 2 2 0 01.5-2.46 4.53 4.53 0 00-.32-.7 4.44 4.44 0 00-.45-.64 2.05 2.05 0 01-.8.12 2 2 0 01-1.87-1.66 4.52 4.52 0 00-1.55 0 2 2 0 01-2.68 1.54 4.53 4.53 0 00-.77 1.35 2 2 0 010 3.08 4.63 4.63 0 00.33.71 4.55 4.55 0 00.44.64 2.02 2.02 0 01.8-.13 2 2 0 011.88 1.67zm.78-2.43a2 2 0 112-2 2 2 0 01-2 2zm0-3a1 1 0 101 1 1 1 0 00-1-1z"}})])
          )
        }
      }
    